import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
// import { Close } from '../../Icons/Close';
import { VillageInfoProps } from '../../interfaces/components';
import ComingSoomImg from '../../assets/images/village_coming_soon.png';

const VillageInfo = ({ active, title, body, comingSoon, onClick, showOnTopRight }: VillageInfoProps) => {
  return (
    <>
      <Box
        zIndex={6}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={showOnTopRight ? ['20px', '20px', '20px'] : 'auto'}
        left="auto"
        bottom={showOnTopRight ? 'auto' : ['20px', '20px', '20px']}
        right={['15px', '15px', '20px']}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding={['25px', '25px', '40px 30px', '40px 30px']}
        width={['90vw', '380px', '450px', '615px', '615px']}
        // height={['220px', '220px', '250px', '220px', '220px']}
        border="1px solid lightgrey"
        // onMouseLeave={onLeave}
        onClick={onClick}
        cursor="pointer"
      >
        {/* <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        /> */}
        <Box display="flex" flexDir={['column', 'column', 'column', 'row']} gap="3">
          <Text
            fontWeight="400"
            fontFamily="SangBleuBPLight"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            width="100%"
            color="#455255"
            casing="uppercase"
          >
            {title}
          </Text>
          {comingSoon && <Image src={ComingSoomImg} w="121px" objectFit="contain" alt="coming-soon" />}
        </Box>
        <Text
          fontWeight="500"
          fontSize={['12px', '12px', '14px', '16px', '16px']}
          width="100%"
          color="#455255"
          fontFamily="JosefinSans"
          mt="5"
        >
          {body}
        </Text>
      </Box>
    </>
  );
};
export default VillageInfo;
